import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { GLOBAL_CONFIG } from 'config/config';
import { PageCard } from 'config/types';
import styles from './home.module.scss';

export const HomePage = () => {
  const navigate = useNavigate();
  const title = GLOBAL_CONFIG.title;
  const cards = GLOBAL_CONFIG.cards;
  
  const goToPage = (card: PageCard) => {
	navigate(card.url);
  };
  
  return (
	<div className={styles.home}>
	  <h2 className={styles.title}>{title}</h2>
	  <div className={styles.cardsWrapper}>
		{cards.map((card, idx) => (
		  <div className={styles.card} key={idx}>
			<img className={styles.cardIcon} src={card.icon} alt=""/>
			<p className={styles.cardTitle}>{card.title}</p>
			<div className={styles.cardAction}>
			  <Button type="primary" size="large" onClick={() => goToPage(card)}>{card.buttonName}</Button>
			</div>
		  </div>
		))}
	  </div>
	</div>
  );
};
